<template>
  <extensions-permission-guard :situation-id="situationId">
    <v-container fluid>
      <v-row>
        <v-col cols="12" lg="10" offset-lg="1">
          <v-row class="mr-8 mb-10 mt-3">
            <v-col cols="10">
              <router-link
                outer-link
                to="/admin/settings/exhibit_management"
                width="100px"
                >← 一覧に戻る</router-link
              >
            </v-col>
            <v-col cols="2">
              <v-btn
                class="light-blue lighten-2"
                style="margin-left: 110px"
                dark
                tile
                @click="update()"
              >
                保存する
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <ExhibitChangeOrder
                :galleries="galleries"
                @change="changeGallery"
              ></ExhibitChangeOrder>
            </v-col>
            <v-col cols="6">
              <ExhibitPreview
                :galleries="galleries"
              >
              </ExhibitPreview>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <DataLoader :loading="loading" />
    </v-container>
  </extensions-permission-guard>
</template>
<script>
import axios from 'axios'
import { deserialize } from 'deserialize-json-api'
import DataLoader from '@/components/commons/DataLoader'
import { EXHIBITS_SITUATION_ID } from '@/mixins/site_permission_utils'
import imageUtilsMixin from '@/mixins/image_utils'
import ExtensionsPermissionGuard from '@/components/commons/ExtensionsPermissionGuard'
import headUtilsMixin from '@/mixins/head_utils'
import ExhibitChangeOrder from '@/components/commons/exhibits/ExhibitChangeOrder'
import ExhibitPreview from '@/components/commons/exhibits/ExhibitPreview'

export default {
  components: {
    DataLoader,
    ExtensionsPermissionGuard,
    ExhibitChangeOrder,
    ExhibitPreview
  },
  mixins: [imageUtilsMixin, headUtilsMixin],
  data: () => {
    return {
      pageTitle: 'ギャラリー表示順変更',
      loading: true,
      situationId: EXHIBITS_SITUATION_ID,
      galleries: [],
      initialGalleries: []
    }
  },
  async mounted () {
    this.loading = true
    await this.fetchGallery()
    this.loading = false
  },
  methods: {
    fetchGallery () {
      return axios.get('/api/gallery_sorts').then(
        ({ data }) => {
          this.galleries = deserialize(data).data
          this.initialGalleries = this.galleries
        },
        (error) => {
          const payload = {
            status: error.response.status,
            message: 'ギャラリーの取得に失敗しました'
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        }
      )
    },
    async update () {
      this.$store.dispatch('LoaderStore/displayLoader')
      if (!this.isGalleriesEqual(this.initialGalleries, this.galleries)) {
        await this.updateGallery()
        const payload = {
          status: 200,
          message: '保存に成功しました。'
        }
        this.$store.dispatch('SystemMessageStore/createMessage', payload)
      }
      this.fetchGallery().finally(() =>
        this.$store.dispatch('LoaderStore/hideLoader')
      )
    },
    updateGallery () {
      const updateGalleries = this.galleries.slice()
      return Promise.all(
        updateGalleries.reverse().map(async (gallery, index) => {
          if (gallery.priority !== index) {
            return new Promise((resolve, reject) =>
              axios
                .patch(`/api/gallery_sorts/${gallery.id}`, {
                  exhibit: { id: gallery.id, priority: index }
                })
                .then(() => {
                  resolve()
                })
                .catch((error) => {
                  const payload = {
                    status: error.response.status,
                    message: error.response.data.message
                  }
                  this.$store.dispatch(
                    'SystemMessageStore/createMessage',
                    payload
                  )
                  reject(error)
                })
                .finally(() => this.$store.dispatch('LoaderStore/hideLoader'))
            )
          }
        })
      )
    },
    isGalleriesEqual (initialGalleries, updateGalleries) {
      var i = initialGalleries.length
      while (i--) {
        if (initialGalleries[i] !== updateGalleries[i]) return false
      }
      return true
    },
    changeGallery (value) {
      this.galleries = value
    }
  }
}
</script>

<style scoped>
.p-exhibit_img {
  cursor: grab;
}
</style>
